import React from 'react';

export default function InvestorCTA() {
  return (
    <section className="w-full bg-gradient-to-br from-purple-800 to-purple-900 text-white py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center space-y-8">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold">
          Let’s Build the Future of Financial Infrastructure
        </h2>
        <p className="text-lg text-gray-200 max-w-xl mx-auto">
          Whether you’re a VC, angel, syndicate, or strategic partner — we’d love to hear from you. We’re ready to share our full investor brief, product demo, and roadmap.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
          <a
            href="mailto:founder@million2trillion.com"
            className="bg-white text-black font-semibold py-3 px-6 rounded-lg shadow hover:bg-gray-100"
          >
            Contact Founder
          </a>
          <a
            href="https://cal.com/mr-senthee/intro"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 px-6 rounded-lg border border-gray-600"
          >
            Book a 15-min Intro Call
          </a>
          <a
            href="/docs/investor-deck.pdf"
            className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-lg shadow"
          >
            Download Investor Deck
          </a>
        </div>

      </div>
    </section>
  );
}
